export enum Direction {
  ROW = 'ROW',
  COLUMN = 'COLUMN',
}
